import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Table } from "semantic-ui-react";
import moment from "moment";

const UiMeet3dEventDetailsMeetingRequest = observer(({ data, t }) => {
  return (
    <Table definition>
      <Table.Body>
        <Table.Row>
          <Table.Cell width={4}>{t("name")}</Table.Cell>
          <Table.Cell>{data.user.name}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell width={4}>{t("email")}</Table.Cell>
          <Table.Cell>{data.user.email}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell width={4}>{t("clientPanelMisc:location")}</Table.Cell>
          <Table.Cell>
            {data.user.location.city ? data.user.location.city : t("clientPanelMisc:locationUnknown")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell width={4}>{t("clientPanelMisc:isRealEstateAgent")}</Table.Cell>
          <Table.Cell>{data.request.isRealEstateAgent ? t("yes") : t("no")}</Table.Cell>
        </Table.Row>
        {data.request.isRealEstateAgent && (
          <Table.Row>
            <Table.Cell width={4}>{t("customer")}</Table.Cell>
            <Table.Cell>
              <Table definition>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell width={4}>{t("name")}</Table.Cell>
                    <Table.Cell>{data.request.contact.name}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={4}>{t("email")}</Table.Cell>
                    <Table.Cell>{data.request.contact.email}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell width={4}>{t("phone")}</Table.Cell>
                    <Table.Cell>{data.request.contact.phone}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
        )}
        {data.request.acceptedDts && (
          <Table.Row>
            <Table.Cell width={4}>{t("clientPanelMisc:acceptedDate")}</Table.Cell>
            <Table.Cell>{moment.unix(data.request.acceptedDts).format("llll")}</Table.Cell>
          </Table.Row>
        )}
        {data.request.declinedDts && (
          <Table.Row>
            <Table.Cell width={4}>{t("clientPanelMisc:declinedDate")}</Table.Cell>
            <Table.Cell>{moment.unix(data.request.declinedDts).format("llll")}</Table.Cell>
          </Table.Row>
        )}
        {data.request.joinedDts && (
          <Table.Row>
            <Table.Cell width={4}>{t("clientPanelMisc:joinedPrivateMeetingDate")}</Table.Cell>
            <Table.Cell>{moment.unix(data.request.joinedDts).format("llll")}</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
});

UiMeet3dEventDetailsMeetingRequest.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default withTranslation()(UiMeet3dEventDetailsMeetingRequest);
